import { dateFormat } from 'constants/formats';
import { format } from 'date-fns';
import i18n from 'i18n/config';
import { useEffect, useState } from 'react';
import { HoldingClass, Range } from 'types';

type UseGetHoldingClassRowDataProps = {
  holdingClass: HoldingClass;
  societyNominalValue: number;
};

export const useGetHoldingClassRowData = ({
  holdingClass,
  societyNominalValue,
}: UseGetHoldingClassRowDataProps) => {
  const [name, setName] = useState<string>('');
  const [nominalValue, setNominalValue] = useState<number>(0);
  const [sharesCount, setSharesCount] = useState<number>(0);
  const [ranges, setRanges] = useState<Range[]>([]);
  const [votes, setVotes] = useState<number>(0);
  const [numerationLabel, setNumerationLabel] = useState<string>('');
  const [liquidationLabel, setLiquidationLabel] = useState<string>('');
  const [antidilutionLabel, setAntidilutionLabel] = useState<string>('');
  const [lockupPeriodLabel, setLockupPeriodLabel] = useState<string>('-');
  const [conversionLabel, setConversionLabel] = useState<string>('');
  const [conversionRate] = useState<number>(holdingClass?.conversionRate || 0);

  useEffect(() => {
    if (!holdingClass) return;

    setName(holdingClass?.name || '');

    setNominalValue(
      holdingClass?.nominalValue ?? societyNominalValue ?? 0
    );

    setSharesCount(holdingClass?.sharesCount?.actual || 0);

    setRanges(holdingClass?.ranges || []);

    setVotes(holdingClass?.votes || 0);

    const numerationOption = holdingClass?.numerationOption as HoldingClass;

    setNumerationLabel(
      numerationOption
        ? numerationOption.name
        : i18n.t('DefaultNumrationReference')
    );

    setLiquidationLabel(
      holdingClass?.hasLiquidationRights ? i18n.t('Yes') : 'No'
    );

    setAntidilutionLabel(
      holdingClass?.hasAntidilutionRights ? i18n.t('Yes') : 'No'
    );

    setLockupPeriodLabel(
      holdingClass?.lockupPeriod
        ? format(new Date(holdingClass?.lockupPeriod), dateFormat)
        : `-`
    );

    setConversionLabel(
      holdingClass?.hasConversionRights ? i18n.t('Yes') : 'No'
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holdingClass, societyNominalValue, i18n.language]);

  return {
    data: {
      name,
      nominalValue,
      sharesCount,
      ranges,
      votes,
      numerationLabel,
      liquidationLabel,
      antidilutionLabel,
      lockupPeriodLabel,
      conversionLabel,
      conversionRate,
    },
  };
};
